import { render, staticRenderFns } from "./CommentCell.vue?vue&type=template&id=77c7696b&scoped=true"
import script from "./CommentCell.vue?vue&type=script&lang=js"
export * from "./CommentCell.vue?vue&type=script&lang=js"
import style0 from "./CommentCell.vue?vue&type=style&index=0&id=77c7696b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c7696b",
  null
  
)

export default component.exports